import React from "react";
import { Box } from "@mui/material";
import { Business } from "@mui/icons-material";
import { HtmlTooltip, IconText } from "../StyledComponents/styled";
import { ListingIconMetric, ListingMetricValue } from "./styles";

/**
 * Icon + company count. Tooltip: company names (A–Z) and inviter emails in two aligned columns;
 * "Shared by" labels the email column only.
 * companies: [{ name, invited_by }]
 */
const CompanyIconCount = ({ companies = [] }) => {
    const sortedAssignments = (Array.isArray(companies) ? [...companies] : [])
        .map((company) => {
            const name = typeof company?.name === "string" ? company.name : "";
            const invitedBy =
                typeof company?.invited_by === "string" && company.invited_by !== ""
                    ? company.invited_by
                    : "N/A";
            return { name, invitedBy };
        })
        .filter((row) => row.name !== "")
        .sort((first, second) => first.name.localeCompare(second.name));

    const tooltipTitle =
        sortedAssignments.length === 0 ? (
            "No company assigned"
        ) : (
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "max-content max-content",
                    width: "max-content",
                    maxWidth: "max-content",
                    columnGap: 1,
                    rowGap: 0.25,
                    alignItems: "baseline",
                }}
            >
                <span aria-hidden="true" />
                <Box component="span" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Invited by
                </Box>
                {sortedAssignments.map((row) => (
                    <React.Fragment key={row.name + "_" + row.invitedBy}>
                        <Box component="span">{row.name}</Box>
                        <Box component="span">{row.invitedBy}</Box>
                    </React.Fragment>
                ))}
            </Box>
        );

    return (
        <HtmlTooltip title={tooltipTitle}>
            <span>
                <ListingIconMetric>
                    <Business sx={{ color: "#AF3241" }} />
                    <ListingMetricValue>
                        <IconText variant="body2">{sortedAssignments.length}</IconText>
                    </ListingMetricValue>
                </ListingIconMetric>
            </span>
        </HtmlTooltip>
    );
};

export default CompanyIconCount;
